import { put, takeEvery } from 'redux-saga/effects';
import {
  ACT_APP_STARTING,
  ACT_COUNTRIES_FETCH_200,
  ACT_DYNASTIES_FETCH_200,
  ACT_TAGS_FETCH_200,
} from '../constants/actions';
import { appStartedAction, appStartingAction } from '../actions/appActions';
import { fetchCountriesAction } from '../actions/countriesActions';
import { dynastiesFetchInitAction } from '../actions/dynastiesActions';
import { fetchTagsInitAction } from '../actions/tagsActions';
import { fetchUsersInitAction } from '../actions/usersActions';


function* startApp() {
  yield put(fetchCountriesAction());
  yield put(dynastiesFetchInitAction());
  yield put(fetchTagsInitAction());
  yield put(fetchUsersInitAction());
}

function* partLoaded() {
  yield put(appStartedAction());
}

export default function* appSagas() {
  yield takeEvery(ACT_APP_STARTING, startApp);
  yield takeEvery([
    ACT_DYNASTIES_FETCH_200,
    ACT_COUNTRIES_FETCH_200,
    ACT_TAGS_FETCH_200,
  ], partLoaded);
  yield put(appStartingAction());
}
